import { useTranslation } from 'react-i18next'
import { getLocaleFromLanguage } from '../../shared/components/custom/Grid/gridFormatUtils'

const useNovuLocalization = () => {
  const { t, i18n } = useTranslation()

  return {
    locale: getLocaleFromLanguage(i18n.language),
    'inbox.filters.labels.default': t('novu:inboxFiltersLabelsDefault'),
    'inbox.filters.labels.unread': t('novu:inboxFiltersLabelsUnread'),
    'inbox.filters.labels.archived': t('novu:inboxFiltersLabelsArchived'),
    'inbox.filters.labels.snoozed': t('novu:inboxFiltersLabelsSnoozed'),
    'inbox.filters.dropdownOptions.default': t('novu:inboxFiltersDropdownOptionsDefault'),
    'inbox.filters.dropdownOptions.unread': t('novu:inboxFiltersDropdownOptionsUnread'),
    'inbox.filters.dropdownOptions.archived': t('novu:inboxFiltersDropdownOptionsArchived'),
    'inbox.filters.dropdownOptions.snoozed': t('novu:inboxFiltersDropdownOptionsSnoozed'),
    'notifications.emptyNotice': t('novu:notificationsEmptyNotice'),
    'notifications.actions.readAll': t('novu:notificationsActionsReadAll'),
    'notifications.actions.archiveAll': t('novu:notificationsActionsArchiveAll'),
    'notifications.actions.archiveRead': t('novu:notificationsActionsArchiveRead'),
    'notifications.newNotifications': ({ notificationCount }: { notificationCount: number }) =>
      t('novu:notificationsNewNotifications', { count: notificationCount }),
    'notification.actions.read.tooltip': t('novu:notificationActionsReadTooltip'),
    'notification.actions.unread.tooltip': t('novu:notificationActionsUnreadTooltip'),
    'notification.actions.archive.tooltip': t('novu:notificationActionsArchiveTooltip'),
    'notification.actions.unarchive.tooltip': t('novu:notificationActionsUnarchiveTooltip'),
    'notification.actions.snooze.tooltip': t('novu:notificationActionsSnoozeTooltip'),
    'notification.actions.unsnooze.tooltip': t('novu:notificationActionsUnsnoozeTooltip'),
    'notification.snoozedUntil': t('novu:notificationSnoozedUntil'),
    'snooze.options.anHourFromNow': t('novu:snoozeOptionsAnHourFromNow'),
    'snooze.options.inOneDay': t('novu:snoozeOptionsInOneDay'),
    'snooze.options.inOneWeek': t('novu:snoozeOptionsInOneWeek'),
    'snooze.options.customTime': t('novu:snoozeOptionsCustomTime'),
    'snooze.datePicker.timePickerLabel': t('novu:snoozeDatePickerTimePickerLabel'),
    'snooze.datePicker.apply': t('novu:snoozeDatePickerApply'),
    'snooze.datePicker.cancel': t('novu:snoozeDatePickerCancel'),
    'snooze.datePicker.pastDateTooltip': t('novu:snoozeDatePickerPastDateTooltip'),
    'snooze.datePicker.noDateSelectedTooltip': t('novu:snoozeDatePickerNoDateSelectedTooltip'),
    'snooze.datePicker.exceedingLimitTooltip': ({ days }: { days: number }) =>
      t('novu:snoozeDatePickerExceedingLimitTooltip', { count: days })
  }
}

export default useNovuLocalization
